import { pageToPath, navigate } from "../seo/routing";

/* A real, crawlable <a href> that navigates client-side (no page reload).
   `to` is a page id from seo/routes.json (e.g. "contact", "product-runr"). */
export default function Link({ to, onClick, children, ...rest }) {
  const handle = (e) => {
    if (onClick) onClick(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || rest.target === "_blank") return;
    e.preventDefault();
    navigate(to);
  };
  return (
    <a href={pageToPath(to)} onClick={handle} {...rest}>
      {children}
    </a>
  );
}
